import { render } from "./AvailableCurrenciesEditor.vue?vue&type=template&id=6520491a&scoped=true"
import script from "./AvailableCurrenciesEditor.vue?vue&type=script&lang=js"
export * from "./AvailableCurrenciesEditor.vue?vue&type=script&lang=js"

import "./AvailableCurrenciesEditor.vue?vue&type=style&index=0&id=6520491a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6520491a"]])

export default __exports__